import { decryptData, encryptData } from "./encryption_decryption";

export function getString(key: string, isEncrypted?:boolean): string | null {
    try {
           const value: string = isEncrypted? decryptData(sessionStorage.getItem(key)) :
           sessionStorage.getItem(key);
           return value;
    } catch (err) {
        return null
    }
}


export function getData<T>(key: string, decrypt?: boolean ): T | null {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;

        return decrypt
            ? (decryptData(raw) as T)
            : (JSON.parse(raw) as T);
    } catch (error: unknown) {
        return null;
    }
}
export function setString(key: string, value: string, isEncrypted?:boolean): void {
    try {
        
        const encryptedValue: string = isEncrypted ?encryptData(JSON.stringify(value))
         : value;
        sessionStorage.setItem(key, encryptedValue);
          
    } catch (err:unknown) {
       
    }
}

export function setData(key: string, value: {} | [], isEncrypted?:boolean): void {
    try {
       const encryptedValue: string = isEncrypted ? encryptData (JSON.stringify(value)):
       JSON.stringify(value);
       sessionStorage.setItem(key, encryptedValue);    
    } catch (err:unknown) {
      
    }
}

export function getStorageData<T>(key: string): T | null {
    try {
        const raw = sessionStorage.getItem(key);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch (error: unknown) {
        return null;
    }
}

export function getStorageString(key: string): string | null {
    try {
           const value: string| null = sessionStorage.getItem(key);
           return value;
    } catch (err) {
        return null
    }
}